import { render, staticRenderFns } from "./Copied.vue?vue&type=template&id=a57c5f72&"
import script from "./Copied.vue?vue&type=script&lang=js&"
export * from "./Copied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports